// extracted by mini-css-extract-plugin
module.exports = {"Modal_container":"ModalResponsive_Modal_container__2A511","Title":"ModalResponsive_Title__3LDqi"};